module.exports = __webpack_public_path__ + "static/media/our-team-member-1.1102ab33.png";